import axios from 'axios';
import Vue from 'vue'
import i18n from "@/i18n";

export default {

    sendContactUsMail (ContactUs) {
        return axios.post('/api/claim/contact-us', ContactUs)
        .then(response => {
            if (response && response.data) 
                {
                    Vue.prototype.$snotify.success(i18n.t('services.users.sendMailContactUs'))
                    return response.data

                }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },
}

